import { Coffee, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import "./HeroActions.css";

export const HeroActions = () => (
  <nav data-testid="hero-primary-actions" aria-label="StatsBet quick actions" className="hero-actions">
    <Button asChild variant="outline" className="hero-action hero-action-social">
      <a data-testid="telegram-pill" href="https://t.me/statsbetting" target="_blank" rel="noopener noreferrer">
        <Send aria-hidden="true" /> Join on Telegram
      </a>
    </Button>
    <Button asChild variant="outline" className="hero-action hero-action-social">
      <a data-testid="bmc-pill" href="https://buymeacoffee.com/bettingstats" target="_blank" rel="noopener noreferrer">
        <Coffee aria-hidden="true" /> Buy Me a Coffee
      </a>
    </Button>
  </nav>
);